import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type {
  GetPresetsParams,
  PaginatedPresetsResponse,
} from '@/features/presets/types';
import { presetApi } from '@/features/presets/api';
import { packKeys } from './pack.keys';

const presetListKey = () => ['packs', 'presets', 'list'] as const;

export function usePresets(
  filters?: GetPresetsParams,
  options?: Omit<UseQueryOptions<PaginatedPresetsResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const query = useQuery({
    queryKey: [...presetListKey(), filters],
    queryFn: ({ signal }) => presetApi.list(filters, signal),
    staleTime: 60_000,
    ...(options as Omit<UseQueryOptions<PaginatedPresetsResponse, Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao buscar presets',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    presets: query.data?.data ?? [],
    totalPages: query.data?.totalPage ?? 1,
    totalItems: query.data?.totalItems ?? 0,
    currentPage: query.data?.page ?? filters?.page ?? 1,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
